// /init supplies both the image origin and the withdrawal policy. Never accept
// a ciphertext string, an empty payload, or an unknown policy as a ready config.
export function withdrawPasswordRequired(info) {
  const value = info && info.isWithdrawPassword
  if (value === undefined || value === null) return null
  const normalized = String(value).trim()
  return normalized === '1' ? true : normalized === '0' ? false : null
}

export function normalizeSystemInfo(data) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return null
  if (withdrawPasswordRequired(data) === null || typeof data.staticDomain !== 'string') return null
  const staticDomain = data.staticDomain.trim()
  if (!/^https?:\/\/[^\s/?#]+(?:\/[^\s?#]*)?$/i.test(staticDomain) &&
      !/^\/\/[^\s/?#]+(?:\/[^\s?#]*)?$/.test(staticDomain)) return null
  return Object.assign({}, data, { staticDomain, isWithdrawPassword: String(data.isWithdrawPassword).trim() })
}

export function createSystemInfoLoader({ request, onReady, wait = ms => new Promise(resolve => setTimeout(resolve, ms)) }) {
  const pending = new WeakMap()
  return function loadSystemInfo({ state, commit }, options = {}) {
    if (pending.has(state)) return pending.get(state)
    if (state.systemInfoStatus === 'ready' && !(options && options.force)) return Promise.resolve(state.linkList)
    commit('SET_SYSTEM_INFO_STATUS', 'loading')
    const task = Promise.resolve().then(async () => {
      for (let attempt = 0; attempt < 3; attempt++) {
        let data = null
        try {
          const result = await request({})
          if (Array.isArray(result) && !result[1]) data = normalizeSystemInfo(result[0])
        } catch (_) { /* Transport and decoding failures use the same retry path. */ }
        if (data) {
          commit('INIT_LIST', data)
          commit('SET_SYSTEM_INFO_STATUS', 'ready')
          // Optional analytics must not prevent images or withdrawal config loading.
          try { if (onReady) onReady(data) } catch (_) { console.warn('Optional tracking initialization failed') }
          return data
        }
        if (attempt < 2) await wait((attempt + 1) * 800)
      }
      commit('SET_SYSTEM_INFO_STATUS', 'error')
      return null
    }).then(result => { pending.delete(state); return result }, error => {
      pending.delete(state)
      commit('SET_SYSTEM_INFO_STATUS', 'error')
      return null
    })
    pending.set(state, task)
    return task
  }
}

export function systemInfoMessages(locale) {
  if (/^zh/i.test(locale || '')) return { loading: '正在加载，请稍候…', failed: '加载失败，请重试。', retry: '重试', account: '账户信息尚未就绪，请稍后重试。' }
  if (/^hi/i.test(locale || '')) return { loading: 'लोड हो रहा है, कृपया प्रतीक्षा करें…', failed: 'लोड नहीं हो पाया। कृपया फिर से कोशिश करें।', retry: 'फिर से कोशिश करें', account: 'खाते की जानकारी अभी तैयार नहीं है। कृपया थोड़ी देर बाद फिर से कोशिश करें।' }
  return { loading: 'Loading, please wait…', failed: 'Unable to load. Please try again.', retry: 'Try again', account: 'Account details are not ready. Please try again shortly.' }
}



// WEBPACK FOOTER //
// ./src/common/utils/system-info.js